import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3 * 60 * 1000,      // ★ data ຖືວ່າ fresh 3 ນາທີ (ບໍ່ refetch ຊ້ຳ)
      cacheTime: 10 * 60 * 1000,      // ★ ເກັບ cache ໄວ້ 10 ນາທີ
      refetchOnWindowFocus: false,     // ★ ບໍ່ refetch ເມື່ອກັບມາທີ່ tab
      retry: 1,                        // ★ retry ແຄ່ 1 ຄັ້ງ (ໄວຂຶ້ນ)
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </QueryClientProvider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ✅ Register Service Worker for PWA (production only — dev ໃຊ້ unregister ເພື່ອບໍ່ cache code ເກົ່າ)
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
